import { useTranslation } from "react-i18next";

import { Badge } from "@/components/ui/badge";

import { OfferStatus } from "../../OfferCard/interfaces";
import { formatOfferDateTime, isProposalFromTrader, statusBadgeVariant } from "../../../utils";
import { MessageBubble } from "../MessageBubble";

export interface OfferCommentDto {
  text: string;
  uuid: string;
  trader_market_offer_id: number;
  trader_market_offer_status: string;
  backend_creation_time: string;
  frontend_creation_time: string;
  user: {
    first_name: string;
    last_name: string;
    roles: string[];
  };
}

export const OfferComment = ({
  comment,
  statusLabel,
}: {
  comment: OfferCommentDto;
  statusLabel: string;
}) => {
  const { t } = useTranslation();

  return (
    <MessageBubble
      own={isProposalFromTrader(comment)}
      userName={`${comment.user?.first_name} ${comment.user?.last_name}`}
      dateTime={formatOfferDateTime(comment.backend_creation_time)}
      badge={
        <Badge variant={statusBadgeVariant(comment.trader_market_offer_status as OfferStatus)}>
          {statusLabel}
        </Badge>
      }
    >
      <div className="mt-2 flex flex-wrap gap-1 text-foreground text-sm">
        <span className="font-semibold">{t("commentCard.comment")}:</span>
        <span>{comment.text}</span>
      </div>
    </MessageBubble>
  );
};
